<template>
  <!-- <tabs class="layout" /> -->
  <div class="vueCalendar">
    <GridScheduler class="layout" />
  </div>
</template>

<script>
import Tabs from "@/components/components-planning/public/calendar/tabs/Tabs";
import GridScheduler from "@/components/components-planning/public/calendar/grid-scheduler/GridScheduler";

export default {
  name: "Home",
  components: {
    Tabs,
    GridScheduler,
  },
};
</script>
<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // margin: 1rem 1rem;
  // border-radius: 15px;
  // height: 100%;
  // width: 100%;
}
</style>
